import React from 'react'
import { Form, FormControl, Col } from 'react-bootstrap'
import UploadImage from '../images/UploadImageContainer'

const CreateArticleTypeView = ({ handleSubmit, genders, sizeCategories, setFilename, setImage }) => {
    let name
    let articleNumber
    let sizeCat
    let colour
    let description
    let price
    let salePrice
    let gender

    /**
     * Creates an articleType object via ref values.
     * @param {any} e button submit default event
     */
    const handleValueChange = (e) => {
        e.preventDefault()

        const articleTypeToCreate = {
            Name: name.value,
            ArticleNumberDesigner: articleNumber.value,
            DescriptionDesigner: description.value,
            Colour: colour.value,
            Gender: gender.value,
            SizeCat: sizeCat.value,
            SizeCatSysId: sizeCategories.find(x => x.Category == sizeCat.value).CategorySysId,
            Price: price.value,
            SalePrice: salePrice.value,
        }
        handleSubmit(articleTypeToCreate)
    }

    return (
        <div lang="de">
            <Form onSubmit={handleValueChange} id='create-article-form'>

                <Form.Group controlId="article-select">

                    <div className="controlTitle">{window.i18n('articleNumber') + ":"}</div>
                    <FormControl required className="form" as="input" ref={node => articleNumber = node}></FormControl>

                    <div className="controlTitle">{window.i18n('name') + ":"}</div>
                    <FormControl required className="form" as="input" ref={node => name = node} ></FormControl>

                    <div className="controlTitle">{window.i18n('description') + ":"}</div>
                    <FormControl className="form" as="textarea" placeholder="Beschreibung..." ref={node => description = node}></FormControl>

                    <div className="controlTitle">{window.i18n('colour') + ":"}</div>
                    <FormControl required className="form" as="textarea" placeholder={window.i18n('colour') + "..."} ref={node => colour = node}></FormControl>

                    <div className="controlTitle">{window.i18n('gender') + ":"}</div>
                    <FormControl required as="select" defaultValue="default" className="form"
                        focusFirstItemOnShow='keyboard' ref={node => gender = node}>
                        <option disabled value="default">{window.i18n('gender') + "..."}</option>
                        {genders.map(entry =>
                            <option>{entry}</option>)
                        }
                    </FormControl>

                    <div className="controlTitle">{window.i18n('sizeCategory') + ":"}</div>
                    <FormControl required as="select" defaultValue="default" className="form"
                        focusFirstItemOnShow='keyboard' ref={node => sizeCat = node}>
                        <option disabled value="default">{window.i18n('sizeCategory') + "..."}</option>
                        {sizeCategories.map(entry =>
                            <option>{entry.Category}</option>)
                        }
                    </FormControl>

                    <div className="controlTitle">{window.i18n('salePrice') + ":"}</div>
                    <Form.Row size="sm" className="input-currency">
                        <Col><FormControl required className="form" type="number" min="0.00" step="0.01" placeholder={window.i18n('price') + " in €..."} ref={node => salePrice = node}></FormControl> </Col>
                        <Col> <p className="input-currency-symbol">€</p> </Col>
                    </Form.Row>

                    <div className="controlTitle">{window.i18n('purchasePrice') + ":"}</div>
                    <Form.Row size="sm" className="input-currency">
                        <Col><FormControl required className="form" type="number" min="0.00" step="0.01" placeholder={window.i18n('price') + " in €..."} ref={node => price = node}></FormControl> </Col>
                        <Col> <p className="input-currency-symbol">€</p> </Col>
                    </Form.Row>

                    <UploadImage setFilename={setFilename} setImage={setImage} />

                </Form.Group>
            </Form>
        </div>
    )
}

export { CreateArticleTypeView }